import { notEmpty } from '@talos/kyoko';
import { useMemo } from 'react';
import { useAppLayoutConfig } from '../../../providers/AppLayoutConfig/AppLayoutConfigContext';
import type { LayoutSection } from '../../../types/LayoutConfig';

/**
 * Shared derived space metadata for a section.
 * Keeps group and label/id lookups in one place for sidebar/edit-space UIs.
 */
export function useSectionSpaceMetadata(layoutSection: LayoutSection) {
  const { layoutConfigs } = useAppLayoutConfig(layoutSection);

  const existingGroups = useMemo(
    () => [...new Set((layoutConfigs ?? []).map(layout => layout.group).filter(notEmpty))],
    [layoutConfigs]
  );

  const sectionLayoutIdsAndLabels = useMemo(
    () => layoutConfigs?.map(layout => ({ id: layout.id, label: layout.label })) ?? [],
    [layoutConfigs]
  );

  return { existingGroups, sectionLayoutIdsAndLabels };
}
